import { get, writable } from 'svelte/store';

import { set_rooms_data_android } from 'src/services/lists_update_android';
import { set_rooms_data_ios } from 'src/services/lists_update_ios';

import { user_data } from 'src/stores/account/user';
import { app, os } from 'src/stores/session/native-bridge';

function create_rooms() {
	const { subscribe, set, update } = writable(JSON.parse(localStorage.getItem('rooms')) || {});

	return {
		subscribe,
		set,
		update: (new_room) =>
			update((rooms) => {
				const existingRoom = rooms[new_room.id];
				// Preserve frontend-only `new` flag for pulse animation
				// Prevents socket updates from wiping pulse animation state
				if (existingRoom?.new && !new_room.new) {
					new_room.new = existingRoom.new;
				}
				return { ...rooms, [new_room.id]: new_room };
			}),
		clearNewFlag: (id) =>
			update((rooms) => {
				if (rooms[id]) {
					delete rooms[id].new;
				}
				return { ...rooms };
			}),
		remove: (id) =>
			update((rooms) => {
				delete rooms[id];
				return rooms;
			}),
		reset: () => set({}),
	};
}

export const rooms = create_rooms();

rooms.subscribe((val) => {
	localStorage.setItem('rooms', JSON.stringify(val));
	if (get(app) && get(user_data).email) {
		console.log('send list data to native ', 'ROOMS', val);
		if (get(os) === 'IOS') {
			set_rooms_data_ios(val);
		} else {
			set_rooms_data_android(val);
		}
	}
});
